<template>
  <div :class="{'order-create__section': !isAdvanced}">

    <template
        v-if="isVisibleProform"
    >

      <div class="mb-2 color-orange-validation" v-if="ex.validation.products">
        {{ $t(`${ex.validationTranslate.products}.localization_value.value`) }}
      </div>
      <template v-for="(item, index) in ex.express.products">
        <div class="order-create__title-horizontal"
             :key="index + '1'"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate([
						'product_Product',
						'common_DeleteProduct',
					])"></div>
          <TitleHorizontal
              :value="$t('product_Product.localization_value.value') + ' #' + parseInt(index + 1)"
              :rightBtn="true"
              :rightBtnType="'delete'"
              :rightBtnText="$t('common_DeleteProduct.localization_value.value')"
              @rightBtnClick="$emit('removeProduct', index)"
          />
        </div>

        <div :key="index">
          <ProductItemCreation
              :key="loadedProformOptions + proformChanged"
              :product="item"
              :serverError="serverError"
              :canChangeHSCode="true"
              :visibleHSCode="ex.express.visibleHSCode"
              :altVersion="true"
              :isShowCustomHS="true"
              :isShowDimensions="isFedex"
              :userId="ex.express.userId"
              :nameForLabel="ex.express.type === FEDEX_DELIVERY_SERVICE.id && isAdmin"
              :extraFieldWeight="isFedex && (isWarehousePyrzowice || isWarehouseLodz ||
                    (isPolandByUser(ex.express.user)) &&
                    (ex.express.sendType === ex.express.sendTypes.sender))"
              @changeCategory="({val, nameVal}) => $emit('changeCategory', {val, nameVal, item: ex.express.products[index]})"
              @changeProformSelectItem="bySaved => {changeProformSelectItem(item, ex.express.delivery.delivery.country); changeProformSelectExpress(bySaved)}"
              @changeSavedProform="val => changeSavedProformExpress(val)"
          />
        </div>
        <!--v-bind:class="{'disabled-product':-->
        <!--$store.getters.getIsAdminRights === 'admin' && Object.keys(item.product.user).length === 0}"-->
      </template>


      <div class="order-create__product-btn add-product-btn-wrap"
           v-bind:class="{'mb-0' : ex.express.type === DHL_DELIVERY_SERVICE.id,
					 	'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}"
      >
        <div class="admin-edit" @click="editTranslate([
							'common_AddProduct',
						])"></div>
        <span class="order-create__product-btn-i add-product-btn site-link"
              @click="$emit('addProduct')"
        >
						+ {{ $t('common_AddProduct.localization_value.value') }}
					</span>
      </div>

      <template v-if="ex.express.type === FEDEX_DELIVERY_SERVICE.id || isGccCpcCertificate">
        <div class="order-create__section-label section-label"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate([
						'express_DocumentsINeed',
					])"></div>
          {{ $t('express_DocumentsINeed.localization_value.value') }}
        </div>

        <div class="custom-row">
          <div class="custom-col d-flex align-items-center mb-3"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editTranslate([
                'express_ToxicSubstance',
                'express_NeededForSuch',
              ])"></div>
            <DefaultCheckbox
                v-model="ex.express.gccCpcCertificate"
                :label="$t('express_GCCCPC.localization_value.value')"
                @click="ex.express.gccCpcCertificate = !ex.express.gccCpcCertificate"
            />
          </div>
          <div class="order-create__col custom-col position-relative"
               :class="{'mb-4' : ex.express.gccCpcCertificateFiles.validation.files, 'mb-2' : !ex.express.gccCpcCertificateFiles.validation.files}"
               v-if="ex.express.gccCpcCertificateFiles.data.maxCountFiles - Object.keys(ex.express.gccCpcCertificateFiles.data.downloadFiles).length > 0 &&
               ex.express.gccCpcCertificate"
          >
            <DropZone
                class="drop-zone-bg"
                :multiple="true"
                :parentFiles="ex.express.gccCpcCertificateFiles.data.files"
                :maxCount="ex.express.gccCpcCertificateFiles.data.maxCountFiles - ex.express.gccCpcCertificateFiles.data.downloadFiles.length"
                :maxSize="ex.express.gccCpcCertificateFiles.data.maxSizeFiles"
                :accept="'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document'"
                @changeImg="changeGccCpcCertificateFile"
            />
            <span class="error-field ml-3" v-if="ex.express.gccCpcCertificateFiles.validation.files">
              {{$t('common_fileIsRequired.localization_value.value')}}
            </span>
          </div>

          <div class="custom-row product-img-row w-100" v-if="Object.keys(ex.express.gccCpcCertificateFiles.data.downloadFiles).length > 0">
            <div class="custom-col custom-col--16 custom-col--md-50 custom-col--sm-100 mt-3"
                 v-for="(file, indexFile) in ex.express.gccCpcCertificateFiles.data.downloadFiles" :key="indexFile">
              <DownloadFileBlock :file="file" @removeFile="(id) => {removeGccCpcCertificateFile(id, indexFile)}"/>
            </div>
          </div>
        </div>

        <template v-if="ex.express.type === FEDEX_DELIVERY_SERVICE.id">
          <div class="custom-row">
            <div class="custom-col d-flex align-items-center mb-3"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate([
                'express_ToxicSubstance',
                'express_NeededForSuch',
              ])"></div>
              <DefaultCheckbox
                  v-model="ex.express.toxicSubstanceControlActCert"
                  :label="''"
                  :disabled="ex.express.toxicSubstanceControlActCertDisabled"
                  @click="ex.express.toxicSubstanceControlActCert = !ex.express.toxicSubstanceControlActCert"
              >
  <!--                @input="changeCert"-->
               <template slot="content">
                 <v-popover
                     class="site-tooltip"
                     offset="5"
                     placement="top"
                     trigger="hover"
                 >
                   {{$t('express_ToxicSubstance.localization_value.value')}}
                   <TooltipBtn/>
                   <template slot="popover">
                     <p><b>{{ $t('express_ToxicSubstance.localization_value.value') }}</b></p>
                     <p>{{ $t('express_NeededForSuch.localization_value.value') }}</p>
                     <a v-close-popover class="tooltip__close"></a>
                   </template>
                 </v-popover>
               </template>
              </DefaultCheckbox>

            </div>
            <div class="custom-col d-flex align-items-center mb-3"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate([
                'express_DropBallTest',
                'express_DropBallTestNeededFor',
              ])"></div>
              <DefaultCheckbox
                  v-model="ex.express.dropBallTestCert"
                  :label="$t('express_DropBallTest.localization_value.value')"
              />
  <!--                @input="changeCert"-->
              <v-popover
                  class="site-tooltip"
                  offset="5"
                  placement="top"
                  trigger="hover"
              >
                <TooltipBtn/>
                <template slot="popover">
                  <p><b>{{ $t('express_DropBallTest.localization_value.value') }}</b></p>
                  <p>{{ $t('express_DropBallTestNeededFor.localization_value.value') }}</p>
                  <a v-close-popover class="tooltip__close"></a>
                </template>
              </v-popover>
            </div>


            <div class="order-create__col custom-col position-relative"
                 v-if="ex.express.additionFiles.data.maxCountFiles - Object.keys(ex.express.additionFiles.data.downloadFiles).length > 0"
            >
              <DropZone class="drop-zone-bg"
                        :multiple="true"
                        :parentFiles="ex.express.additionFiles.data.files"
                        :maxCount="ex.express.additionFiles.data.maxCountFiles - ex.express.additionFiles.data.downloadFiles.length"
                        :maxSize="ex.express.additionFiles.data.maxSizeFiles"
                        :accept="'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document'"
                        @changeImg="changeAdditionFile"
              />
              <span class="error-field ml-3" v-if="ex.express.additionFiles.validation.files">
                  {{$t('common_fileIsRequired.localization_value.value')}}
                </span>
            </div>

            <div class="custom-row product-img-row w-100"
                 v-if="Object.keys(ex.express.additionFiles.data.downloadFiles).length > 0"
            >
              <div class="custom-col custom-col--16 custom-col--md-50 custom-col--sm-100 mt-3"
                   v-for="(file, indexFile) in ex.express.additionFiles.data.downloadFiles"
                   :key="indexFile"
              >
                <DownloadFileBlock
                    :file="file"
                    @removeFile="(id) => {removeAdditionFile(id)}"
                />
              </div>

            </div>
          </div>
        </template>

      </template>

      <div class="order-create__total"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
						'common_TotalShippingCost',
						'express_orderPriceValidate',
					])"></div>
        {{ $t('common_TotalShippingCost.localization_value.value') }}

        <span>
					${{ calculatePrice }}
				</span>
        <div
            :key="ex.validation.orderPrice"
            v-if="ex.validation.orderPrice"
            v-bind:class="{'ui-no-valid': ex.validation.orderPrice}">
          <div class="error-field error-field-right pr-2">
            {{ $t(`${ex.validationTranslate.orderPrice}.localization_value.value`) }}
            (${{ parseFloat(ex.express.orderPrice).toFixed(2) }})
          </div>

        </div>
      </div>

    </template>

    <template v-else>
      <ProductsDescription
          :ex="ex"
      />
    </template>

    <PromoCode
        v-if="ex.express.type === NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE.id || isNPI"
        :ex="ex"
    />

  </div>
</template>

<script>
import TitleHorizontal from "../../../../../../coreComponents/TitleHorizontal/TitleHorizontal";
import {mixinDetictingMobile} from "../../../../../../../mixins/mobileFunctions";
import ProductItemCreation from "../../../../../../coreComponents/ProductItemCreation/ProductItemCreation";
import DefaultCheckbox from "../../../../../../UI/checkboxes/DefaultCheckbox/DefaultCheckbox";
import TooltipBtn from "../../../../../../UI/tooltips/TooltipBtn/TooltipBtn";
import {
  DHL_DELIVERY_SERVICE,
  FEDEX_DELIVERY_SERVICE,
  NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE
} from "../../../../../../../staticData/staticVariables";
import {expressMixins} from "../../../../../../../mixins/expressMixins/expressMixin";
import {proformMixins} from "../../../../../../../mixins/proformMixins/proformMixins";
import PromoCode from "@/components/modules/ExpressOrdersModule/components/chunks/UserBlocks/PromoCode/PromoCode";
import ProductsDescription
  from "@/components/modules/ExpressOrdersModule/components/chunks/UserBlocks/ProductsDescription/ProductsDescription";
import DropZone from "@/components/coreComponents/DropZone/DropZone";
// import CloseIcon from '../../../../../../../../public/img/modal-group/close-icon.svg?inline'
import DownloadFileBlock from "@/components/coreComponents/DownloadFileBlock/DownloadFileBlock";


export default {
  name: "ProductsDetails",
  components: {
    ProductsDescription,
    DownloadFileBlock,
    DropZone,
    PromoCode,
    TooltipBtn,
    DefaultCheckbox,
    TitleHorizontal,
    ProductItemCreation,
    // CloseIcon,
  },

  props: {
    ex: Object,
    loadedProformOptions: {
      type: Number,
      default: 0,
    },
    proformChanged: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isAdvanced: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [mixinDetictingMobile, expressMixins, proformMixins],

  //cuz admin isn't forced to select country first
  mounted() {
    if (!this.isEdit && this.isAdmin && this.ex.express.type === DHL_DELIVERY_SERVICE.id) {
      this.ex.setVisibleHSCode(true)
    }
  },

  data() {
    return {
      options: [{}],


      valueQuantity: 1,
      valueSum: 0,
      valueSumDisable: 100,

      DHL_DELIVERY_SERVICE: DHL_DELIVERY_SERVICE,
      FEDEX_DELIVERY_SERVICE: FEDEX_DELIVERY_SERVICE,
      NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE: NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE,

      isHovering: false,
      tooltipAddProductActive: true,
      serverError: false,

      product: {
        sku: '',
        skuOption: [{}],
        categoryOption: [{}],
        categorySelected: '',
        nameUa: '',
        nameEn: '',
        forUa: '',
        forEn: '',
        materialUa: '',
        materialEn: '',
        subMaterialUa: '',
        subMaterialEn: '',
        valueQuantity: '',
        valueSum: '',
      }
    }
  },

  computed: {
    getToxicSubstanceControlActCert() {
      return this.ex.express.toxicSubstanceControlActCert
    },
    getDropBallTestCert() {
      return this.ex.express.dropBallTestCert
    },


  // 	calculatePrice() {
  // 		let price = 0
  // 		this.ex.express.products.map(item => {
  // 			console.log(parseFloat(item.product.price * item.product.itemsQuantity));
  // 			price += parseFloat(item.product.price * item.product.itemsQuantity)
  // 		})
  //
  // 		return this.$options.filters.number(price, '0.00')
  // 	},
  },

  watch: {
    // getToxicSubstanceControlActCert() {
    //   this.changeCert()
    // },
    // getDropBallTestCert() {
    //   this.changeCert()
    // },
  },


  methods: {

    // changeCert() {
    //   if(this.ex.express.toxicSubstanceControlActCert || this.ex.express.dropBallTestCert) {
    //     this.ex.express.additionFiles.data.maxCountFiles = 1
    //   } else {
    //     this.ex.express.additionFiles.data.maxCountFiles = 0
    //   }
    //   // let countFiles = 3
    //   // if(this.ex.express.toxicSubstanceControlActCert) {
    //   //   countFiles--
    //   // }
    //   // if(this.ex.express.dropBallTestCert){
    //   //   countFiles--
    //   // }
    //   // this.ex.express.additionFiles.data.maxCountFiles = countFiles
    // },

    changeValueQuantity(data) {
      this.valueQuantity = data
    },

    changeValueSum(data) {
      this.valueSum = data
    },

    changeProductNameEn() {
      console.log('changeProductNameEn')
    },

    changeProductNameUa() {
      console.log('changeProductNameUa')
    },

    removeAdditionFile(id) {
      this.$store.dispatch('removeUserDocument', id).then(() => {
        this.ex.removeAdditionFile(id)
        this.images = id
      })
    },

    removeGccCpcCertificateFile(id, index) {
      let text = {
        title: 'common_deleteConfirm',
        txt: '',
        yes: 'common_confirm',
        no: 'common_confirmNo'
      }

      let confirm = () => {
        this.$store.dispatch('removeUserDocument', id).then((response) => {
          switch (this.getResponseStatus(response)) {
              /**
               * Success
               */
            case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
              this.ex.express.gccCpcCertificateFiles.removeDownloadFile(index)
              this.openNotify('success', 'common_notificationRecordDeleted')
              break
            }
              /**
               * Validation Error
               */
            case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
              let errors = response.response.data.errors;
              this.notifyErrorHelper(errors)
              break
            }
              /**
               * Undefined Error
               */
            default: {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          }
        }).catch(error => this.createErrorLog(error))

        this.$store.commit('setConfirmDeletePopup', false)
        return true
      }

      this.deleteFunc(text, confirm)
    },

    changeGccCpcCertificateFile(files, maxSizeError) {
      this.ex.express.gccCpcCertificateFiles.setFiles(files)

      this.ex.express.gccCpcCertificateFiles.setFilesMaxSizeError(maxSizeError)
    },

    changeAdditionFile(files, maxSizeError) {
      this.ex.express.additionFiles.setFiles(files)

      this.ex.express.additionFiles.setFilesMaxSizeError(maxSizeError)
    },

    openPdf(base64) {
      this.globalOpenPdfBase64(base64)
    },

  }
}
</script>

<style scoped>

.error-field-right {
  left: auto;
  right: 0;
  font-size: 14px;
}

.order-create__total .ui-no-valid {
  position: relative;
}
</style>
